import "core-js/stable";
import Vue from "vue";
import App from "./survey-tool/App.vue";
import store from "./survey-tool/store/index.js";
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";
import { ResizeObserver as ResizeObserverPolyfill } from "@juggle/resize-observer";

import surveyTool from "../scss/survey-tool.scss";

//polyfill for ResizeObserver
if (typeof window !== "undefined") {
  window.ResizeObserver = window.ResizeObserver || ResizeObserverPolyfill;
}

Vue.use(LottieVuePlayer);

/**
 * Set the slide content
 * **/
function hydrateApp() {
  let surveyContent = window.surveyContent ? window.surveyContent : {};

  console.log("survey-tools.js - surveyContent: ", surveyContent);

  store.commit("updateField", {
    path: "content",
    value: surveyContent,
  });
}

/**
 * Set up config
 * **/
function init() {
  hydrateApp();
  new Vue({
    el: "#survey-tool",
    store,
    render: (h) => h(App),
  });
}

/**
 * jQuery like $(document).ready() method that you can call from anywhere
 * **/
function docReady(fn) {
  // see if DOM is already available
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

/**
 * Document ready let's do our stuff
 * **/
docReady(function () {
  // DOM is loaded and ready for manipulation here
  init();
});
